import { map } from 'rxjs/operators';
import { Injector } from '@angular/core';

import { SgEntityFetchAdapter } from '../components/entity-select-auto-complete';
import { validateArrayType } from './utils/validate-array';
import { InstrumentsManagerApi, InstrumentsManagerApiClient } from '@sg/api/instruments-manager-api';

declare module '../components/entity-select-auto-complete/entity-select-fetch-store.service' {
  export interface SgEntitySelectEntityFetchMap {
    CompositeTicker: {
      entity: InstrumentsManagerApi.InstrumentDto;
      query: InstrumentsManagerApi.InstrumentSearchParamsDto;
    };
  }
}

export class CompositeTickerApiToEntityFetcherLink implements SgEntityFetchAdapter<'CompositeTicker'> {
  readonly key: 'CompositeTicker' = 'CompositeTicker';
  readonly metadata: {
    idField: keyof InstrumentsManagerApi.InstrumentDto;
    labelField: keyof InstrumentsManagerApi.InstrumentDto;
    queryField?: { field: keyof InstrumentsManagerApi.InstrumentSearchParamsDto; isArray?: boolean };
  } = {
    idField: 'data.currentIdentifiers.compositeTicker' as keyof InstrumentsManagerApi.InstrumentDto,
    labelField: 'data.currentIdentifiers.compositeTicker' as keyof InstrumentsManagerApi.InstrumentDto,
    queryField: { field: 'compositeTickers', isArray: true },
  };

  private readonly instrumentsManagerApi: InstrumentsManagerApiClient;

  constructor(injector: Injector) {
    this.instrumentsManagerApi = injector.get(InstrumentsManagerApiClient);
  }

  getEntity(compositeTickers: string[]) {
    const body: InstrumentsManagerApi.InstrumentSearchParamsDto = {
      compositeTickers: validateArrayType(compositeTickers),
    };
    return this.instrumentsManagerApi
      .instrumentsManagerControllerPostInstrumentsSearch({ body, pageNumber: 1 }, { observe: 'body' })
      .pipe(map((results) => results.rows));
  }

  findEntities(query?: InstrumentsManagerApi.InstrumentSearchParamsDto & { name: string[] }, pageNumber?: number) {
    const body: InstrumentsManagerApi.InstrumentSearchParamsDto = {};

    if (query) {
      Object.assign(body, query);
    }

    return this.instrumentsManagerApi
      .instrumentsManagerControllerPostInstrumentsSearch(
        { body, pageSize: 10, pageNumber: pageNumber ?? 1 },
        { observe: 'body' }
      )
      .pipe(
        map((result) => {
          return {
            data: result.rows ? result.rows : [],
            infiniteScrollInfo: { currentPage: result.paging.pageNumber, totalPages: result.paging.totalPages },
          };
        })
      );
  }
}
